import { coreApi, payableApi } from "../client";
import { EMPLOYEE, PAYABLE, PAYROLL_ENTRY } from "../endpoints";

export const getViewGrid = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.FILTER, payload);
  return res.data;
};

export const deletePayrollEntry = async (payrollId) => {
  const res = await coreApi.post(`${PAYROLL_ENTRY.DELETE}?PayrollID=${payrollId}`);
  return res.data;
};

export const loadPayPeriodSetup = async (payrollId) => {
  const res = await coreApi.post(`${PAYROLL_ENTRY.LOAD_PAY_PERIOD}?PayrollID=${payrollId}`);
  return res.data;
};

export const updatePayPeriodSetup = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.UPDATE_PAY_PERIOD, payload);
  return res.data;
};

export const getLoadEmpPayrollDetails = async (payrollId, pageNum = 1) => {
  const page = Number(pageNum);
  const apiPageNum = !isNaN(page) && page > 0 ? page - 1 : 0;
  const res = await coreApi.post(
    `${PAYROLL_ENTRY.LOAD_EMP_DETAILS}?PayrollID=${payrollId}&PageNum=${apiPageNum}`
  );
  return res.data;
};

export const getPayrollEmployeeDetails = async (payrollEmpID) => {
  const res = await coreApi.post(`${PAYROLL_ENTRY.GET_EMP_MAPPING}?reqID=${payrollEmpID}`);
  return res.data;
}

export const UpdatePayrollEmployeeMapping = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.UPDATE_EMP_MAPPING, payload);
  return res.data;
}

export const getDefaultDateRange = async () => {
  const res = await payableApi.get(PAYABLE.DATE_RANGE);
  return res.data;
}

export const getBillEntryPreferences = async () => {
  const res = await payableApi.get(PAYABLE.BILL_ENTRY_PREF);
  return res.data;
}

export const getDeptJobDetails = async (EmployeeId) => {
  const res = await coreApi.post(`${PAYROLL_ENTRY.GET_DEPT_JOB}?EmployeeId=${EmployeeId}`);
  return res.data;
};

export const updateVoidDate = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.VOID_PAYROLL, payload);
  return res.data;
};

export const isLock = async (payload) => {
  const res = await payableApi.post(PAYABLE.LOCK_CHECK, payload);
  return res.data;
};

export const getValidatePassword = async (corpId, password) => {
  const res = await payableApi.get(PAYABLE.VALIDATE_PASSWORD, {
    params: { CorpID: corpId, Password: password }
  }
  );
  return res.data;
};
export const PreviousPayrollByCorp = async (corpId) => {
  const res = await coreApi.get(PAYROLL_ENTRY.PREVIOUS_PAYROLL_BY_CORP, {
    params: { CorpID: corpId }
  }
  );
  return res.data;
};
export const loadEmployees = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.LOAD_EMPLOYEES, payload);
  return res.data;
};
export const savePayrollEmployee = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.SAVE_PAYROLL_EMPLOYEE, payload);
  return res.data;
};
export const getPayrollItemNames = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.GET_PAYROLL_ITEM_NAMES, payload);
  return res.data;
};
export const GetPayrollDetails = async (payload) => {
  const res = await coreApi.post(EMPLOYEE.PAYROLL_DETAILS, payload);
  return res.data;
};


export const getPayrollItemAccounts = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.GET_PAYROLL_ITEM_ACC, payload);
  return res.data;
};


export const saveOrEditPayrollEmpMapping = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.SAVE_EDIT_EMPLOYEE, payload);
  return res.data;
};

export const deletePayrollEmployee = async (payrollEmpID) => {
  const res = await coreApi.post(`${PAYROLL_ENTRY.DELETE_EMPLOYEE}?PayrollEmpID=${payrollEmpID}`);
  return res.data;
}

export const getPayrollVendorTypes = async () => {
  const res = await coreApi.post(PAYROLL_ENTRY.VENDOR_TYPE);
  return res.data;
};

export const getAskAISuggestion = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.ASK_AI, payload);
  return res.data;
};

export const multiSavePayrollItemDetailUpdate = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.MULTI_SAVE, payload);
  return res.data;
};

export const getUnmatchedPayrollQueue = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.UNMATCHED_PAYROLL_QUEUE, payload);
  return res.data;
};

export const getVendorPref = async (corpId, pcId) => {
  const url = pcId
    ? `${PAYROLL_ENTRY.VENDOR_PREF}?CorpID=${corpId}&PCID=${pcId}`
    : `${PAYROLL_ENTRY.VENDOR_PREF}?CorpID=${corpId}`;
  const res = await coreApi.post(url);
  return res.data;
};

export const getPayrollItemTypeMapping = async (payrollId) => {
  const res = await coreApi.get(`${PAYROLL_ENTRY.GET_PAYROLL_ITEM_TYPE_MAPPING}?payrollID=${payrollId}`);
  return res.data;
};

export const getPayPreferenceItemTypeMapping = async () => {
  const res = await coreApi.get(PAYROLL_ENTRY.GET_PAY_PREFERENCE_ITEM_TYPE_MAPPING);
  return res.data;
};

export const updatePayrollItemTypeMapping = async (payload) => {
  const res = await coreApi.post(PAYROLL_ENTRY.UPDATE_PAYROLL_ITEM_TYPE_MAPPING, payload);
  return res.data;
};

export const downloadSampleTemplate = async (fileName, folderName = "TEMPLATES/payroll") => {
  const payload = typeof fileName === "object" && fileName !== null
    ? fileName
    : {
        CorporationID: null,
        RefID: null,
        Type: null,
        FolderPath: null,
        Files: [
          {
            FileName: fileName,
            Message: null,
            Length: 0,
            Status: 0,
            AwsPath: null,
          },
        ],
        StatusCode: 0,
        Status: null,
      };

  const res = await coreApi.post(
    `${PAYROLL_ENTRY.SAMPLE_TEMPLATES}?folderName=${encodeURIComponent(folderName)}`,
    payload
  );
  return res.data;
};
